import React, { memo, useEffect, useMemo, useState } from 'react';
import { RotatingSquare } from 'react-loader-spinner';

import './CrawlLoader.scss';
import { useTranslation } from 'react-i18next';
import { Fade } from '@mui/material';

const CrawlLoader = ({ isLoading, width = 100, disableScrolling, scrollableRef }) => {
  const [fixedTop, setFixedTop] = useState(0);
  const { t } = useTranslation('sonar');

  useEffect(() => {
    if (!disableScrolling || !scrollableRef) {
      return;
    }
    const scrollableContainer = scrollableRef?.current;

    const scrollTop = scrollableContainer.scrollTop;
    setFixedTop(scrollTop ?? 0);

    const handlePreventParentScroll = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    if (isLoading) {
      scrollableContainer.addEventListener('wheel', handlePreventParentScroll, {
        passive: false,
      });
      scrollableContainer.addEventListener('touchmove', handlePreventParentScroll, {
        passive: false,
      });
    } else {
      scrollableContainer.removeEventListener('wheel', handlePreventParentScroll, {
        passive: false,
      });
      scrollableContainer.removeEventListener('touchmove', handlePreventParentScroll, {
        passive: false,
      });
    }

    return () => {
      scrollableContainer.removeEventListener('wheel', handlePreventParentScroll, {
        passive: false,
      });
      scrollableContainer.removeEventListener('touchmove', handlePreventParentScroll, {
        passive: false,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, disableScrolling]);

  const fixedStyles = useMemo(
    () => ({
      top: `${fixedTop}px`,
    }),
    [fixedTop],
  );

  return (
    <Fade in={isLoading}>
      <div className='crawl-loader_overlay' style={fixedStyles}>
        <div className='crawl-loader_title-block'>
          <span className='crawl-loader_title-text'>{t('crawling')}</span>
          <RotatingSquare
            visible={true}
            animationDuration='0.75'
            height={width}
            width={width}
            color='#fdbf47'
            ariaLabel='rotating-square-loading'
          />
        </div>

        <span className='crawl-loader_warning'>{t('takeSomeTime')}</span>
      </div>
    </Fade>
  );
};

export default memo(CrawlLoader);
